var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.14 174.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffd92b;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fb507e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.04,6.12l17.08,47.44c1.34,3.71,4.26,6.63,7.96,7.96l47.44,17.08c8.17,2.94,8.17,14.49,0,17.43l-47.44,17.08c-3.71,1.34-6.63,4.26-7.96,7.96l-17.08,47.44c-2.94,8.17-14.49,8.17-17.43,0l-17.08-47.44c-1.34-3.71-4.26-6.63-7.96-7.96L6.12,96.04c-8.17-2.94-8.17-14.49,0-17.43l47.44-17.08c3.71-1.34,6.63-4.26,7.96-7.96L78.61,6.12c2.94-8.17,14.49-8.17,17.43,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.54,105.64l5.65,13.62c.7,1.7,2.12,2.99,3.88,3.54l13.57,4.24c4.67,1.46,4.67,8.06,0,9.52l-13.57,4.24c-1.75.55-3.17,1.84-3.88,3.54l-5.65,13.62c-1.7,4.1-7.51,4.1-9.21,0l-5.65-13.62c-.7-1.7-2.12-2.99-3.88-3.54l-13.57-4.24c-4.67-1.46-4.67-8.06,0-9.52l13.57-4.24c1.75-.55,3.17-1.84,3.88-3.54l5.65-13.62c1.7-4.1,7.51-4.1,9.21,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginStars);
export default __webpack_public_path__ + "static/media/login-stars.56ba32165b677871c68a28f9a694b79c.svg";
export { ForwardRef as ReactComponent };